module.exports = __webpack_public_path__ + "static/img/12.aec3c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/12.png
// module id = tvge
// module chunks = 0